export default ["src/pages/home/about/About.vue","src/pages/home/index/Index.vue","src/pages/home/new/New.vue","src/pages/home/project/Project.vue"]